module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjE1MSIgdmlld0JveD0iMCAwIDMwMSAxNTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMDA5QjQ4IiBkPSJNLjUuNWgxMDB2MTUwSC41eiIvPjxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0xMDAuNS41aDEwMHYxNTBoLTEwMHoiLz48cGF0aCBmaWxsPSIjRkY3OTAwIiBkPSJNMjAwLjUuNWgxMDB2MTUwaC0xMDB6Ii8+PC9nPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-ie.svg
// module id = qfxB
// module chunks = 2